/* ==========================================================================
   Scroll Product Showcase
   Drives the pinned-scroll product cycling animation.
   Drop this file in Assets as: section-scroll-showcase.js
   ========================================================================== */

window.ScrollShowcase = (function () {
  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var pinWrap = root.querySelector('.scroll-showcase__pin-wrap');
    var products = Array.prototype.slice.call(
      root.querySelectorAll('.scroll-showcase__product')
    );
    var dots = Array.prototype.slice.call(
      root.querySelectorAll('.scroll-showcase__dot')
    );

    if (!pinWrap || products.length === 0) return;

    // Give the pin-wrap enough scroll height for the number of products.
    // e.g. 4 products => 400vh of scroll room to cycle through them.
    function setPinHeight() {
      pinWrap.style.height = products.length * 100 + 'vh';
    }
    setPinHeight();

    var activeIndex = -1;

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;

      products.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
    }

    function getProgress() {
      var rect = pinWrap.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var total = rect.height - viewportHeight;
      if (total <= 0) return 0;

      var scrolled = -rect.top;
      return Math.max(0, Math.min(1, scrolled / total));
    }

    function onScroll() {
      var rect = pinWrap.getBoundingClientRect();
      var viewportHeight = window.innerHeight;

      // Before entering / after leaving, keep first/last product visible.
      if (rect.top > 0) {
        setActive(0);
        return;
      }
      if (rect.bottom <= viewportHeight) {
        setActive(products.length - 1);
        return;
      }

      var progress = getProgress();
      var index = Math.min(
        products.length - 1,
        Math.floor(progress * products.length)
      );
      setActive(index);
    }

    // Clicking a dot scrolls the page so that product becomes active.
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var rect = pinWrap.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var total = rect.height - viewportHeight;
        if (total <= 0) return;

        var docTop = window.scrollY + rect.top;
        // Target the middle of this product's scroll segment so it lands
        // solidly on that product rather than right at its edge.
        var targetProgress = (index + 0.5) / products.length;
        var targetY = docTop + targetProgress * total;

        window.scrollTo({ top: targetY, behavior: 'smooth' });
      });
    });

    // Reduced motion: just show the first product, skip scroll-driven cycling
    var prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      setActive(0);
      return;
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            onScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      setPinHeight();
      onScroll();
    });

    // Initial state
    setActive(0);
    onScroll();
  }

  return { init: init };
})();